import { render, staticRenderFns } from "./terms-of-service-for-minor.vue?vue&type=template&id=e905b8a6&scoped=true&"
import script from "./terms-of-service-for-minor.vue?vue&type=script&lang=js&"
export * from "./terms-of-service-for-minor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e905b8a6",
  null
  
)

export default component.exports